module.exports = __webpack_public_path__ + "static/media/boy2.8cd4227f.svg";